import {useEffect, useState} from "react";
import {searchInit} from "./init/searchInit";
import {useMutation} from "@tanstack/react-query";
import {paginationInit} from "../../../common/init/PaginationInit";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {RolesInfoInterface} from "../create/interface/RolesInterface";
import {deleteDutyGroupApi, readAllDutyGroupsApi} from "../../../../api/manage/role/DutyGroupApi";
import {useModal} from "../../../../hooks";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import {useSearchParams} from "react-router-dom";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const RoleList = () => {
    const {handleModal} = useModal();
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const {goToNavigation} = useGoToNavigation();

    const [searchData, setSearchData] = useState<RolesInfoInterface[]>([]);
    const [dataCount, setDataCount] = useState(0);
    const [searchParam, setSearchParam] = useState(searchInit)
    const [allChecked, setAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState<Set<number>>(new Set());
    const [currentPage, setCurrentPage] = useState(paginationInit);

    const handleAllCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setAllChecked(isChecked);
        setCheckedItems(new Set(isChecked ? searchData.map((item: any) => item.dutyGroupId) : [])); // dutyGroupId  로 수정
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, dutyGroupId: number) => {
        const newCheckedItems = new Set(checkedItems);
        e.target.checked ? newCheckedItems.add(dutyGroupId) : newCheckedItems.delete(dutyGroupId);
        setCheckedItems(newCheckedItems);
        setAllChecked(newCheckedItems.size === searchData.length);
    };

    const deleteCallback = () => {
        const data = searchData.filter(data => checkedItems.has(data.dutyGroupId as any));
        deleteDutyGroupApiMutate.mutate(data)
    }

    const deleteItems = () => {
        if (checkedItems.size > 0) {
            handleModal({isOpen: true, contents: "선택된 역할을 삭제하시겠습니까?", type: "confirm", callback: deleteCallback})
        } else {
            handleModal({isOpen: true, contents: "삭제할 역할을 선택해주세요.", type: "alert"})
        }
    };

    const readAllDutyGroupsApiMutate = useMutation({
        mutationFn: () => readAllDutyGroupsApi(searchParam),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setSearchData(res.data.result?.userList ?? []);
                setDataCount(res.data.result?.totalCount ?? 0)
            } else {
                setSearchData([]);
                setDataCount(0)
            }
        },
        onError: res => {
            alert(res)
        }
    });

    const deleteDutyGroupApiMutate = useMutation({
        mutationFn: (data: any) => deleteDutyGroupApi(data),
        onSuccess: res => {
            if (res.data.code === "0000") {
                handleModal({isOpen: true, contents: "역할이 삭제되었습니다.", type: "alert"})
                readAllDutyGroupsApiMutate.mutate()
            } else {
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(() => {
        readAllDutyGroupsApiMutate.mutate()
    }, [])

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page});
        setAllChecked(false); // 페이지 변경 시 최상위 체크박스 초기화
        setCheckedItems(new Set()); // 페이지 변경 시 체크된 항목 초기화
    }, [page])

    useEffect(() => {
        readAllDutyGroupsApiMutate.mutate()
    }, [searchParam.pageNo])

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">역할 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select"
                                    onChange={(e) => setSearchParam({...searchParam, keywordType: e.target.value})}>
                                <option value={'0'}>전체</option>
                                <option value={'1'}>역할 ID</option>
                                <option value={'2'}>역할</option>
                            </select>
                            <input type="text"
                                   className="form-control"
                                   onChange={(e) => setSearchParam({...searchParam, keyword: e.target.value})}
                                   onKeyDown={e => e.key === "Enter" ? readAllDutyGroupsApiMutate.mutate() : ""}
                            />
                            <button className="btn btn-info btn_search"
                                    onClick={() => readAllDutyGroupsApiMutate.mutate()}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">역할 목록(<span>{dataCount}</span>건)</h6>
                    <div className="table_toolbar">
                        <AuthorityChecker authorityNames={['roleWriteYn']}>
                            <button className="btn btn-outline-dark ms-40px" onClick={deleteItems}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon_cross.png`} alt=""/>선택삭제
                            </button>
                            <button className="btn btn-primary"
                                    onClick={() => goToNavigation(`manage/role/create`, "", false)}>역할 생성
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                {/* 내부수정: table_scroll 삭제 */}
                <table className="table table-bordered my_table">
                    <thead>
                    <tr>
                        <AuthorityChecker authorityNames={['roleWriteYn']}>
                            <th style={{width: "4.4%"}}>
                                <input
                                    type="checkbox"
                                    checked={allChecked}
                                    onChange={handleAllCheckboxChange}
                                />
                            </th>
                        </AuthorityChecker>
                        <th>역할ID</th>
                        <th>역할</th>
                        <th>구분</th>
                        <th>조직</th>
                        <th>설명</th>
                        <th>구성원 수</th>
                    </tr>
                    </thead>
                    <tbody>
                    {searchData && searchData.length > 0 ? (
                        searchData.map(item => (
                            <tr key={item.dutyGroupName}
                                className="clickable"
                                onClick={() => goToNavigation(`manage/role/detail/${item.dutyGroupId}`, "", false)}>
                                <AuthorityChecker authorityNames={['roleWriteYn']}>
                                    <td className="text-center" style={{width: "4.4%"}}
                                        onClick={e => e.stopPropagation()}>
                                        <input
                                            type="checkbox"
                                            checked={checkedItems.has(item.dutyGroupId || 0)}
                                            onChange={e => handleCheckboxChange(e, item.dutyGroupId || 0)}
                                        />
                                    </td>
                                </AuthorityChecker>
                                <td className="text-center">{item.dutyGroupName || "-"}</td>
                                <td className="text-center">{item.roleName || "-"}</td>
                                <td className="text-center">{item.dutyGroupTypeName || "-"}</td>
                                <td>{item.orgName || "-"}</td>
                                <td className="text-center">{item.dutyGroupRemark || "-"}</td>
                                <td className="text-center"><DisplayNumber value={item.memberCount || 0}/></td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={7} className="text-center">데이터가 없습니다.</td>
                        </tr>
                    )}
                    </tbody>
                </table>

                <PaginationMain totalCount={dataCount ?? 0}/>
            </div>
        </>
    );
}